import {
    AfterViewInit, Component, ContentChildren, ElementRef, Input, QueryList, Renderer2, ViewChild,
    ViewEncapsulation
} from '@angular/core';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/combineLatest';
import { MatIcon } from '@angular/material';
import { bindFunctionsToThis } from '../../../extensions';
import { BaseComponent } from '../../base.component';

@Component({
    selector: 'ig-actions',
    templateUrl: './actions.component.html',
    styleUrls: ['./actions.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        '[class]': 'class'
    }
})
export class ActionsComponent extends BaseComponent implements AfterViewInit {
    private showTriggerTimeout: any;

    public isShowing: boolean;
    @Input() public class: string;
    @Input() public toggleByParent: boolean;
    @Input() public animationDelay = 100;
    @Input() public animationGap = 25;
    @ViewChild('iconButtons') public iconButtons: any;
    @ViewChild('trigger') public trigger: ElementRef;
    @ContentChildren(MatIcon) public matIcons: QueryList<MatIcon>;

    constructor(private renderer: Renderer2) {
        super();
        bindFunctionsToThis(this);
    }

    public ngAfterViewInit() {
        this.matIcons
            .changes
            .startWith(this.matIcons.toArray())
            .takeUntil(this.isDestroyed)
            .subscribe(() => {
                let icons = Array.from(this.iconButtons.nativeElement.querySelectorAll('mat-icon'));
                icons.forEach((icon: HTMLElement, index: number) => {
                    icon.style.transitionDelay = `${this.animationDelay + (index + 1) * this.animationGap}ms`;
                });
            });
    }

    public show() {
        if (this.showTriggerTimeout) {
            clearTimeout(this.showTriggerTimeout);
        }

        this.isShowing = true;
        this.renderer.setStyle(this.trigger.nativeElement, 'opacity', '0');
    }

    public hide() {
        this.isShowing = false;

        let icons = Array.from(this.iconButtons.nativeElement.querySelectorAll('mat-icon'));
        let allIconsHideAnimationTiming = icons.length * 25 + 250;

        this.showTriggerTimeout = setTimeout(() => {
            this.renderer.setStyle(this.trigger.nativeElement, 'opacity', '1');
        }, allIconsHideAnimationTiming);
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/row.action.buttons/actions/actions.component.ts